<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      color="#85344c"
    ></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Vendas</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{erroMensagem}}</span>
            </div>
          </div>
        </div>
        <v-card>
          <v-card-title>Suas Vendas
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="vendas" :search="search">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.protocolo }}</td>
              <td>{{ props.item.nome_completo }}</td>
              <td>R$ {{ centavos(props.item.custom_price) }}</td>
              <td>{{ props.item.plans_description }}</td>
              <td>{{ padronizaData(props.item.updated_at) }}</td>
              <td class="text-xs-right">
                <router-link
                  :to="'/corretor/vendas/detalhes/' + props.item.subscriber_id"
                  class="btn_1 gray delete wishlist_close"
                >
                  <i class="fa fa-fw fa-edit"></i> Detalhes
                </router-link>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from 'axios';

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      search: "",
      erroMensagem: "",
      mostraErro: false,
      headers: [
        { text: "Protocolo", value: "protocolo" },
        { text: "Beneficiário", value: "nome_completo" },
        { text: "Valor", value: "custom_price" },
        { text: "Planos", value: "plans_description" },
        { text: "Data", value: "updated_at" },
        { text: "Opções", value: "" },
      ],
      vendas: [],
      isLoading: false
    };
  },
  mounted() {
    this.isLoading = true;
    const token = localStorage.getItem("token_adm_comprodonto")
      ? JSON.parse(localStorage.getItem("token_adm_comprodonto")).token
      : null;
    axios.get(`vendas_por_corretor/${this.parseJwt(token).usr.id}`).then(res => res.data).then(res => {
      this.vendas = res;
      this.vendas.map((venda) => {
        venda.nome_completo = venda.name + " " + venda.last_name;
      })
      this.isLoading = false;
    }).catch(er => {
      this.isLoading = false;
      this.$swal.fire({
            position: "center",
            type: "error",
            title: "Erro ao buscar vendas",
            showConfirmButton: true,
      });
    })
  },
  methods: {
    parseJwt(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },
  },

};
</script>